import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { ControlFunction } from "./controlFunction";
const loader = new GLTFLoader();
import { progressbar, modelsLoaded } from "./progressbar";

const loadShelfAf = () => {
    const promiseShelfAf = new Promise((resolve, reject) => {
        loader.load(
            "office/model/shelf_af/shalf_af2.gltf",
            function (gltf) {
                scene.add(gltf.scene);
                const model = gltf.scene;

                // Posizione di default più visibile al centro della stanza
                model.position.set(-2.2471539303761956, 2.157179317921158, 10.080979531159333);
                model.rotation.set(-3.141592653589793, 0.009691671660779, -3.141592653589793);


                model.scale.set(1, 1, 1);



                model.traverse(function (object) {
                    if (object.isMesh) {
                        console.log("ShelfAF mesh found:", object.name);
                        object.castShadow = true;
                        object.receiveShadow = true;
                    }
                });

                // Attiviamo il gizmo per posizionarlo interattivamente
                // Una volta trovata la posizione, puoi leggere i valori in console
                //ControlFunction(model);

                resolve(model);
                progressbar();
            },
            undefined,
            function (error) {
                console.error(error);
                reject(error);
            }
        );
    });
    return promiseShelfAf;
};

export { loadShelfAf };
